import React from 'react'
import PropTypes from 'prop-types'
import { UtilCommon, UtilDevice, Bridge } from '@iskytrip/sdk'
import CSS from './index.module.css'
import BaseComponent from '@base/BaseComponent'
import playIcon from '@assets/icon/playIcon.png'
import { Modal } from 'antd-mobile'
import PlayVideo from '@pages/pickUpPerson/playVideo'

let video
let scrollTop

// iOS上正常
// Android上有问题
class GLVideoItem extends BaseComponent {
	static propTypes = {
		videoUrl: PropTypes.string,
		preView: PropTypes.string,
		itemWidth: PropTypes.string,
		itemHeight: PropTypes.string,
	}

	static defaultProps = {
		videoUrl: '',
		preView: '',
		itemWidth: '3.25rem',
		itemHeight: '1.82rem',
	}

	constructor(props) {
		super(props)
		this.videoRef = React.createRef()
		this.state = {
			isShowVideo: false,
		}
		document.addEventListener('fullscreenchange', this.fullscreenAction.bind(this))
	}

	componentDidMount() {
		const self = this
		const dsBridge = require('dsbridge')
		Bridge.callHandler('ListenAndroidBack', {
			result: 2, // 1不监听/2监听
		})
		dsBridge.registerAsyn('AndroidBackListener', (data, callback) => {
			alert(self.state.isShowVideo)
			// 1执行关闭/2不执行
			self.setState({
				isShowVideo: false,
			})
			callback &&
				callback(
					JSON.stringify({
						result: 2,
					}),
				)
		})
	}

	fullscreenAction() {
		if (document.fullscreenElement) {
			console.log('进入全屏')
			scrollTop = document.documentElement.scrollTop // 滚动条滚动高度
			if (scrollTop === 0) {
				scrollTop = document.body.scrollTop // 滚动条滚动高度
			}
			video.play()
			video.controls = true
		} else {
			document.documentElement.scrollTop = scrollTop
			video.pause()
			video.controls = false
		}
	}

	playAction() {
		if (UtilDevice.isIOS()) {
			video = this.videoRef.current
			if (video.paused) {
				video.play()
			} else {
				video.pause()
			}
			if (video.requestFullscreen) {
				video.requestFullscreen()
			} else if (video.mozRequestFullScreen) {
				video.mozRequestFullScreen()
			} else if (video.webkitRequestFullScreen) {
				video.webkitRequestFullScreen()
			}
		} else {
			this.setState({
				isShowVideo: true,
			})
		}
	}

	hiddenAlert() {
		const self = this
		alert(this.state.isShowVideo)
		this.setState(
			{
				isShowVideo: false,
			},
			function() {
				alert(self.state.isShowVideo)
			},
		)
	}

	render() {
		let { videoUrl, preView, itemWidth, itemHeight } = this.props
		// videoUrl = 'https://static.iskytrip.com/activity/springfestival_20200115/image/video.mp4'

		return (
			<div
				className={CSS.videoItem}
				onClick={this.playAction.bind(this)}
				style={{ width: itemWidth, height: itemHeight }}
			>
				<video
					poster={preView}
					controlsList='nodownload nofullscreen noremoteplayback'
					ref={this.videoRef}
				>
					<source src={videoUrl || ''} type='video/mp4' />
				</video>
				<img src={UtilCommon.creatImgUrl(preView, 6)} alt='' />
				<img src={playIcon} alt='' />

				{/* 弹框-播放视频 */}
				<Modal visible={this.state.isShowVideo}>
					<PlayVideo showType='pop' url={videoUrl} close={this.hiddenAlert.bind(this)} />
				</Modal>
			</div>
		)
	}
}

export default GLVideoItem
